/*
 * Author: Dw
 * File Created: Monday, 25-05-19 02:58 pm
 * Last Modified: Thursday, 25-06-19 06:12 pm, by Ben Zhao
 */

import { useCallback, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { showDialogAsync } from '@ucard/ds/message';
import { isOpenApi } from '@web/utils';
import { useMarketingStore } from '../../stores/useMarketingStore';
import { useUserInfo } from '../../stores/useUserStore';
import AccountMgntFee from './dialog';
const useAccountMgntFee = () => {
  const [loading, setLoading] = useState(true);
  const [exec, setExec] = useState<boolean>(false);
  const router = useRouter();
  const {
    isLogin
  } = useUserInfo();
  const fnRef = useRef<any>();
  const {
    getAccountManagementFeeData,
    accountManagementFee
  } = useMarketingStore();
  fnRef.current = async () => {
    if (!exec) {
      return true;
    }
    const {
      isShow
    } = accountManagementFee ?? {};
    if (!isShow) {
      return true;
    }
    await showDialogAsync(AccountMgntFee, {
      disableBackdropClose: true
    });
  };
  const getAccountInfo = useCallback(async () => {
    try {
      await getAccountManagementFeeData();
      setExec(true);
    } catch (e) {
      console.log('ERR', e);
    } finally {
      setLoading(false);
    }
  }, [getAccountManagementFeeData]);
  useEffect(() => {
    // 如果接口有数据则不调用
    // 不能是landing页面
    // 不能是 openAPI
    if (router.pathname !== '/landing/home' && !isOpenApi && isLogin && !accountManagementFee?.userId) {
      getAccountInfo();
    } else {
      setLoading(false);
    }
  }, [getAccountInfo, isLogin, router.pathname, accountManagementFee]);
  return {
    loading,
    fn: () => fnRef.current()
  };
};
export default useAccountMgntFee;